import { motion } from 'framer-motion';

import PlayIcon from "../../img/play.svg";

const SignUpPopUp = ({ title, mobileViewTitle }) => {
  return (
    <motion.div
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -20, opacity: 0 }}
      transition={{
        type: "spring",
        stiffness: 500,
        damping: 20
      }}
      className='flex justify-between items-center p-2 sm:py-2 sm:px-6 rounded-[12px] bg-[#F2F4FC] border-[1px] border-[#4659CA] mb-2'
    >
      <div className='flex gap-2 items-center font-gilroy-bold'>
        <img src={PlayIcon} alt='playIcon' height={20} width={20} />
        <span className='text-[14px] leading-5 sm:text-[16px] sm:leading-6 sm:block hidden'>{title}</span>
        <span className='text-[14px] leading-5 sm:text-[16px] sm:leading-6 sm:hidden block'>{mobileViewTitle}</span>
      </div>
      <a className='py-1 px-3 sm:px-4 bg-[#3940A0] text-white rounded-[12px] text-[12px] sm:text-[14px] leading-5 whitespace-nowrap' href={"/signup"}>Sign up now</a>
    </motion.div>
  );
};

export default SignUpPopUp;
